import Vue from "vue";
import { abilitiesPlugin, Can } from "@casl/vue";

import ability from "@/services/ability";

// Default @casl/vue plugin, adds $ability and $can helpers to Vue Components.
Vue.use(abilitiesPlugin, ability);

// Register Can component globally
Vue.component("Can", Can);
